<template>
  <div id="">
    <vxe-grid v-bind="addTableList" @cell-dblclick="dbClick" :cell-style="cellStyle">
      <template v-slot:toolbar>
        <vxe-toolbar custom>
          <template v-slot:buttons>
            <vxe-form>
              <vxe-form-item>
                <template v-slot>
                  <vxe-input ref="addUserDialog" v-model="searchVal" :placeholder="$t('message.placeholder.search')" @keyup.enter.native="searchClick"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template v-slot>
                  <vxe-button status="primary" @click="searchClick">{{
                    $t("message.button.search")
                  }}</vxe-button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </template>
        </vxe-toolbar>
      </template>
    </vxe-grid>
  </div>
</template>

<style scoped></style>

<script>
export default {
  name: "searchAdd", //模板名称
  data() {
    return {
      searchVal: "",
      get_change_info: "",
      rols_text: [],
      tableShow: false,
      oldTableValue: [],
      rols_text: [],
      cols: [],
      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],

        data: [],
        
        sortConfig: {
          trigger: "cell",
        },
      },
    };
  },
  mounted() {},
  methods: {
    cellStyle({ row, rowIndex, column}){
      if(row.enabled == 0) {
        return {
          // backgroundColor: '#f07381',
          color: '#ff0b00'
        }
      }
    },
    dbClick(row) {
      // console.log(row);
      if (!row.row.enabled) {
        this.$message.error(this.$t("message.error.disabledUser"))
        return
      }
      this.$emit("listDbClick", row.row);
    },
    async searchClick() {
      //console.log(this.searchVal);
      var val = this.searchVal;
      var vm = this;
      const {
          //获取标题
          data: res,
        } = await this.$http.get("/pmdm/admin/user/getUsers?loginId=" + val);
        // console.log(res);
        if (res.code == 200) {
          if (res.object.users.length == 0) {
            vm.$message({
              showClose: true,
              message: this.$t("message.warning.searchErr_02"),
              type: "warning",
            });
            this.addTableList.data = [];
          } else {
            var items = res.object.users;
            // console.log(items);
            var tableContent = [];
            items.map((i) =>  tableContent.push(i));
            
            this.addTableList.data = tableContent;
            this.addTableList.columns = [
              // { field: "itemNumber", title: "id", sortable: true },
              {
                field: "displayUserName",
                title: this.$t("message.table.userName"),
                sortable: true,
              },
              {
                field: "enabled",
                title: this.$t("message.table.status"),
                sortable: true,
                editRender: {
                  name: "$select",
                  options: [
                    {
                      label: this.$t("message.table.enabled_01"),
                      value: 1,
                    },
                    {
                      label: this.$t("message.table.disabled_01"),
                      value: 0,
                    },
                  ],
                },
              },
              
            ];
          }
        }
      // if (val == "") {
      //   vm.$message({
      //     showClose: true,
      //     message: this.$t("message.warning.searchErr_01"),
      //     type: "warning",
      //   });
      // } else {
        
      // }
    },
  },
  created() {
    this.$nextTick(()=>{
      this.$refs.addUserDialog.focus();//获取搜索框焦点
    })
  },
};
</script>
